export default "__VITE_ASSET__BQdQgh3U__"